var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"sign-up-via-email-modal","height":"auto","width":430,"adaptive":true,"clickToClose":false},on:{"before-open":_vm.beforeOpenModal,"opened":_vm.blockScroll,"closed":_vm.unblockScroll}},[_c('SignInViaEmailForm',{attrs:{"isModal":true},on:{"goBack":_vm.goBack,"onSignUp":_vm.onSignUp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }